<app-dialog
  #dialog
  [key]="dialogKey"
  [action]="'risk-rfq-emails'"
  [headerTheme]="'simple'"
  [title]="'Histórico de Emails da RFQ'"
  [hideDefaultFooter]="true"
  [showMaximizeButton]="true"
  [maxWidth]="'1680px'"
  [maxHeight]="'90vh'"
  [disableContentScroll]="true"
  [scrollableContent]="false"
  (onClose)="onDialogClosed()">
  <div class="rfq-emails-modal">
    <div class="rfq-emails-modal__toolbar">
      <div class="rfq-emails-modal__toolbar-info">
        <div class="rfq-emails-modal__pill">
          <span class="rfq-emails-modal__pill-label">RFQ</span>
          <span class="rfq-emails-modal__pill-value">#{{ currentRfq()?.sequentialId }}</span>
        </div>
        <div class="rfq-emails-modal__pill">
          <span class="rfq-emails-modal__pill-label">Pedidos</span>
          <span class="rfq-emails-modal__pill-value">{{ getInstrumentCountLabel() }}</span>
        </div>
        <div class="rfq-emails-modal__pill">
          <span class="rfq-emails-modal__pill-label">Tipos</span>
          <span class="rfq-emails-modal__pill-value">{{ getInstrumentTypesLabel() }}</span>
        </div>
        <div class="rfq-emails-modal__pill">
          <span class="rfq-emails-modal__pill-label">Histórico</span>
          <span class="rfq-emails-modal__pill-value">{{ emails().length }} email(s)</span>
        </div>
      </div>
    </div>

    <div
      class="rfq-emails-modal__content"
      [class.rfq-emails-modal__content--list-collapsed]="isListCollapsed() && !!selectedEmail()">
      <aside class="rfq-emails-modal__sidebar">
        <div class="rfq-emails-modal__sidebar-header">
          <div class="rfq-emails-modal__filters">
            <button
              type="button"
              class="rfq-emails-modal__filter-btn"
              [class.rfq-emails-modal__filter-btn--active]="filterDirection() === 'All'"
              (click)="setFilter('All')">
              Todos
            </button>
            <button
              type="button"
              class="rfq-emails-modal__filter-btn"
              [class.rfq-emails-modal__filter-btn--active]="filterDirection() === 'Inbound'"
              (click)="setFilter('Inbound')">
              Recebidos
            </button>
            <button
              type="button"
              class="rfq-emails-modal__filter-btn"
              [class.rfq-emails-modal__filter-btn--active]="filterDirection() === 'Outbound'"
              (click)="setFilter('Outbound')">
              Enviados
            </button>
          </div>
        </div>

        @if (isLoading()) {
          <div class="rfq-emails-modal__state">
            <app-cog-loading-spinner />
            <span>Carregando emails...</span>
          </div>
        } @else if (errorMessage()) {
          <div class="rfq-emails-modal__state rfq-emails-modal__state--error">
            <i class="pi pi-exclamation-triangle"></i>
            <span>{{ errorMessage() }}</span>
          </div>
        } @else if (!emails().length) {
          <div class="rfq-emails-modal__state">
            <i class="pi pi-envelope"></i>
            <span>Esta RFQ ainda não possui emails registrados.</span>
          </div>
        } @else {
          <div class="rfq-emails-modal__list">
            @for (email of filteredEmails(); track email.id) {
              <button
                type="button"
                class="rfq-emails-modal__item"
                [class.rfq-emails-modal__item--active]="selectedEmail()?.id === email.id"
                (click)="selectEmail(email)">
                <div class="rfq-emails-modal__item-top">
                  <span class="rfq-emails-modal__badge" [attr.data-direction]="email.direction">
                    {{ getDirectionLabel(email.direction) }}
                  </span>
                  @if (emailHasAnalyses(email.id)) {
                    <span class="rfq-emails-modal__ai-tag">
                      <i class="pi pi-sparkles"></i> AI
                    </span>
                  }
                  <span class="rfq-emails-modal__item-date">{{
                    email.sentAt | vaultDateTime
                  }}</span>
                </div>
                <div class="rfq-emails-modal__item-main-row">
                  @if (email.bankCompensationCode) {
                    <app-bank-logo
                      [code]="email.bankCompensationCode"
                      [maxWidth]="24"
                      [marginRight]="0" />
                  }
                  <div class="rfq-emails-modal__item-main">
                    <strong>{{ email.bankName || 'Banco não identificado' }}</strong>
                    <span class="rfq-emails-modal__item-counterparty">{{
                      getSidebarCounterpartyLabel(email)
                    }}</span>
                    <span class="rfq-emails-modal__item-subject">{{ email.subject }}</span>
                  </div>
                </div>
                <p>{{ email.latestText || 'Sem prévia textual disponível.' }}</p>
              </button>
            }
          </div>
        }
      </aside>

      <section class="rfq-emails-modal__detail" #detailSection>
        @if (!selectedEmail() && !isLoading() && !errorMessage()) {
          <div class="rfq-emails-modal__state">
            <i class="pi pi-mouse"></i>
            <span>Selecione um email da lista para visualizar o conteúdo completo.</span>
          </div>
        } @else if (selectedEmail(); as email) {
          <div class="rfq-emails-modal__detail-card">
            <div class="rfq-emails-modal__detail-header">
              <div class="rfq-emails-modal__detail-main-info">
                <div class="rfq-emails-modal__detail-topline">
                  <button
                    type="button"
                    class="rfq-emails-modal__toggle-list"
                    (click)="toggleList()"
                    [attr.aria-expanded]="!isListCollapsed()"
                    [attr.aria-label]="
                      isListCollapsed() ? 'Mostrar lista de emails' : 'Recolher lista de emails'
                    "
                    [pTooltip]="
                      isListCollapsed()
                        ? 'Mostrar lista de emails'
                        : 'Recolher lista e ler com a largura toda'
                    "
                    tooltipPosition="bottom">
                    <i
                      class="pi"
                      [class.pi-angle-double-left]="!isListCollapsed()"
                      [class.pi-angle-double-right]="isListCollapsed()"></i>
                  </button>
                  <span class="rfq-emails-modal__badge" [attr.data-direction]="email.direction">
                    {{ getDirectionLabel(email.direction) }}
                  </span>
                  <span class="rfq-emails-modal__detail-date">{{
                    email.sentAt | vaultDateTime
                  }}</span>

                  <button
                    type="button"
                    class="rfq-emails-modal__toggle-details"
                    (click)="toggleHeader()">
                    {{ isHeaderExpanded() ? 'Esconder detalhes' : 'Ver detalhes' }}
                    <i
                      class="pi"
                      [class.pi-chevron-down]="!isHeaderExpanded()"
                      [class.pi-chevron-up]="isHeaderExpanded()"></i>
                  </button>

                  @if (getDownloadableAttachments(email).length) {
                    <div class="rfq-emails-modal__attachments-inline">
                      <button
                        type="button"
                        class="rfq-emails-modal__attachments-toggle"
                        [class.rfq-emails-modal__attachments-toggle--active]="showAttachments()"
                        (click)="toggleAttachments()"
                        pTooltip="Ver anexos"
                        tooltipPosition="bottom">
                        <i class="pi pi-paperclip"></i>
                        <span class="rfq-emails-modal__attachments-count">{{
                          getDownloadableAttachments(email).length
                        }}</span>
                      </button>

                      @if (showAttachments()) {
                        <div
                          class="rfq-emails-modal__attachments-dropdown"
                          (click)="$event.stopPropagation()">
                          <div class="rfq-emails-modal__attachments-dropdown-header">
                            <span>Anexos</span>
                            <button
                              type="button"
                              class="rfq-emails-modal__attachments-close"
                              (click)="closeAttachments()"
                              title="Fechar anexos"
                              aria-label="Fechar anexos"
                              pTooltip="Fechar"
                              tooltipPosition="left">
                              <i class="pi pi-times"></i>
                            </button>
                          </div>
                          <div class="rfq-emails-modal__attachments-list">
                            @for (
                              attachment of getDownloadableAttachments(email);
                              track attachment.blobName
                            ) {
                              <div
                                class="rfq-emails-modal__attachment-item"
                                (click)="openAttachment(attachment)"
                                pTooltip="Clique para abrir"
                                tooltipPosition="top">
                                <div class="rfq-emails-modal__attachment-icon">
                                  <i [class]="getFileIcon(attachment.filename)"></i>
                                </div>
                                <div class="rfq-emails-modal__attachment-name">
                                  {{ attachment.filename }}
                                </div>
                                <div class="rfq-emails-modal__attachment-size">
                                  {{ formatFileSize(attachment.size) }}
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      }
                    </div>
                  }
                </div>
                <h3>{{ email.subject }}</h3>
                @if (!isHeaderExpanded()) {
                  <div class="rfq-emails-modal__collapsed-info">
                    <span>De: {{ email.from }}</span>
                  </div>
                }
              </div>

              <div class="rfq-emails-modal__bank-info">
                <app-bank-logo [code]="email.bankCompensationCode" [maxWidth]="32" />
                <div>
                  <strong>{{ email.bankName }}</strong>
                  <span>Código: {{ email.bankCompensationCode }}</span>
                </div>
              </div>
            </div>

            @if (isHeaderExpanded()) {
              <div class="rfq-emails-modal__metadata">
                <div class="rfq-emails-modal__metadata-row">
                  <span class="rfq-emails-modal__metadata-label">De:</span>
                  <span class="rfq-emails-modal__metadata-value">{{
                    email.from || email.repliedFromName || '-'
                  }}</span>
                </div>
                <div class="rfq-emails-modal__metadata-row">
                  <span class="rfq-emails-modal__metadata-label">Para:</span>
                  <span class="rfq-emails-modal__metadata-value">{{
                    getParticipantList(email.to)
                  }}</span>
                </div>
                <div class="rfq-emails-modal__metadata-row">
                  <span class="rfq-emails-modal__metadata-label">CC:</span>
                  <span class="rfq-emails-modal__metadata-value">{{
                    getParticipantList(email.cc)
                  }}</span>
                </div>
                <div class="rfq-emails-modal__metadata-grid">
                  <div class="rfq-emails-modal__metadata-item">
                    <span class="rfq-emails-modal__metadata-label">Contato:</span>
                    <span class="rfq-emails-modal__metadata-value">{{
                      email.bankManagerName || email.repliedFromName || '-'
                    }}</span>
                  </div>
                  <div class="rfq-emails-modal__metadata-item">
                    <span class="rfq-emails-modal__metadata-label">Cargo:</span>
                    <span class="rfq-emails-modal__metadata-value">{{
                      email.bankManagerPosition || '-'
                    }}</span>
                  </div>
                  <div class="rfq-emails-modal__metadata-item">
                    <span class="rfq-emails-modal__metadata-label">Provider:</span>
                    <span class="rfq-emails-modal__metadata-value">{{
                      email.provider || '-'
                    }}</span>
                  </div>
                </div>
              </div>
            }

            @if (aiQuoteRows().length) {
              <div class="rfq-emails-modal__ai-panel">
                <button
                  type="button"
                  class="rfq-emails-modal__ai-panel-header"
                  [attr.aria-expanded]="isAiPanelExpanded()"
                  (click)="toggleAiPanel()">
                  <div class="rfq-emails-modal__ai-panel-title">
                    <i class="pi pi-sparkles"></i>
                    <span>Cog AI · Cotações extraídas</span>
                    <span class="rfq-emails-modal__ai-panel-count"
                      >{{ aiQuoteRows().length }}
                      {{ aiQuoteRows().length === 1 ? 'item' : 'itens' }}</span
                    >
                    <span class="rfq-emails-modal__ai-panel-summary">{{ aiQuoteSummary() }}</span>
                  </div>
                  <i
                    class="pi"
                    [class.pi-chevron-up]="isAiPanelExpanded()"
                    [class.pi-chevron-down]="!isAiPanelExpanded()"></i>
                </button>

                @if (isAiPanelExpanded()) {
                  <div class="rfq-emails-modal__ai-panel-body" (scroll)="hideInsightNow()">
                    <table class="rfq-emails-modal__ai-table">
                      <thead>
                        <tr>
                          <th>Instrumento</th>
                          <th>Vencimento</th>
                          <th class="rfq-emails-modal__ai-num">Notional</th>
                          <th>Cotação</th>
                          <th class="rfq-emails-modal__ai-note-col">Nota</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (row of aiQuoteRows(); track row.key) {
                          <tr
                            class="rfq-emails-modal__ai-row"
                            [class.rfq-emails-modal__ai-row--warn]="row.insight.hasWarning">
                            <td class="rfq-emails-modal__ai-kind">
                              {{ formatInstrumentKind(row.item?.kind ?? row.quote?.kind) }}
                            </td>
                            <td>
                              {{
                                row.item?.maturityDate ? (row.item!.maturityDate | vaultDate) : '-'
                              }}
                            </td>
                            <td class="rfq-emails-modal__ai-num">
                              @if (
                                row.item?.notional !== null && row.item?.notional !== undefined
                              ) {
                                {{ row.item!.currencyCode }}
                                {{ row.item!.notional | vaultFormatCurrency: 2 : '' }}
                              } @else {
                                -
                              }
                            </td>
                            <td>
                              @if (row.quote) {
                                <span class="rfq-emails-modal__ai-quote-row">
                                  @for (field of row.fields; track field.label) {
                                    <span class="rfq-emails-modal__ai-field">
                                      <span class="rfq-emails-modal__ai-field-label">{{
                                        field.label
                                      }}</span>
                                      <span class="rfq-emails-modal__ai-field-value">
                                        @if (field.type === 'number') {
                                          {{
                                            field.value !== null && field.value !== undefined
                                              ? (field.value
                                                | vaultFormatCurrency: field.digits || 2 : '')
                                              : '-'
                                          }}
                                        } @else {
                                          {{ field.value || '-' }}
                                        }
                                      </span>
                                    </span>
                                  }
                                </span>
                              } @else {
                                <span class="rfq-emails-modal__ai-no-quote">
                                  <i class="pi pi-exclamation-circle"></i> Sem cotação estruturada
                                </span>
                              }
                            </td>
                            <td class="rfq-emails-modal__ai-note-col">
                              <button
                                type="button"
                                class="rfq-emails-modal__ai-note-icon"
                                [class.rfq-emails-modal__ai-note-icon--warn]="
                                  row.insight.hasWarning
                                "
                                [class.rfq-emails-modal__ai-note-icon--active]="
                                  insightPopover()?.key === row.key
                                "
                                [attr.aria-label]="
                                  row.insight.hasWarning
                                    ? 'Leitura da cotação, com pontos a conferir'
                                    : 'Leitura da cotação'
                                "
                                [attr.aria-expanded]="insightPopover()?.key === row.key"
                                [attr.aria-describedby]="
                                  insightPopover()?.key === row.key ? 'rfq-insight-pop' : null
                                "
                                (mouseenter)="showInsight($event, row)"
                                (mouseleave)="scheduleInsightHide()"
                                (focus)="showInsight($event, row)"
                                (blur)="scheduleInsightHide()"
                                (click)="toggleInsight($event, row)">
                                <i
                                  class="pi"
                                  [class.pi-info-circle]="!row.insight.hasWarning"
                                  [class.pi-exclamation-triangle]="row.insight.hasWarning"></i>
                              </button>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                }
              </div>
            }

            <div class="rfq-emails-modal__body">
              <iframe
                [src]="selectedEmailIframeSrc()"
                class="rfq-emails-modal__iframe"
                title="Conteúdo do Email"
                frameborder="0"
                scrolling="auto">
              </iframe>
            </div>
          </div>
        }
        @if (insightPopover(); as pop) {
          <div
            #insightPop
            id="rfq-insight-pop"
            class="rfq-emails-modal__insight-pop"
            role="tooltip"
            [style.right.px]="pop.right"
            [style.top.px]="pop.top"
            [style.bottom.px]="pop.bottom"
            (mouseenter)="cancelInsightHide()"
            (mouseleave)="scheduleInsightHide()">
            <strong class="rfq-emails-modal__insight-pop-title">{{ pop.insight.title }}</strong>
            <ul>
              @for (line of pop.insight.lines; track $index) {
                <li [attr.data-tone]="line.tone">
                  <i
                    class="pi"
                    [class.pi-circle-fill]="line.tone === 'info'"
                    [class.pi-check-circle]="line.tone === 'ok'"
                    [class.pi-exclamation-triangle]="line.tone === 'warn'"></i>
                  <span>{{ line.text }}</span>
                </li>
              }
            </ul>
            @if (pop.insight.responder) {
              <p class="rfq-emails-modal__insight-pop-responder">
                <i class="pi pi-user"></i> {{ pop.insight.responder }}
              </p>
            }
          </div>
        }
      </section>
    </div>
  </div>
</app-dialog>
